module.exports = __webpack_public_path__ + "img/glt-logo.42923c73.png";